import type { Region } from '~~/core/entities/Region';
import type { RegionService } from '~~/core/ports/services/RegionService';

import { Result } from '~~/core/helpers/result';
import { createOriginalErrorObject } from '~~/server/utils/errorHandling';

// Futuramente usaremos um serviço externo para armazenar as informações dos bairros, por isso não criamos essa parte como um repositório
export const nuxtRegionService: RegionService = {
	async getMany() {
		try {
			const response = await $fetch<Region[]>('/api/region', {
				method: 'GET'
			});

			return Result.ok(response || []);
		} catch (error) {
			return Result.error({
				message: 'Error while getting featured regions.',
				source: 'nuxtRegionService.getMany',
				originalErrorObject: createOriginalErrorObject(error)
			});
		}
	},
	async getOne({ slug }) {
		try {
			const response = await $fetch<Region | null>(
				`/api/region/${encodeURIComponent(slug)}`,
				{
					method: 'GET'
				}
			);

			return Result.ok(response || null);
		} catch (error) {
			return Result.error({
				message: `Error while getting the region with slug ${slug}.`,
				source: 'nuxtRegionService.getOne',
				originalErrorObject: createOriginalErrorObject(error)
			});
		}
	}
};
